import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

/**
 * redirect root page to HISinOne portal
 */
@Component( {
    templateUrl: './his-startpage.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisStartpageComponent implements OnInit {

    ngOnInit() {
        window.location.href = '../../pages/cs/sys/portal/hisinoneStartPage.faces';
    }
}
